import { environment } from '@accredible-frontend-v2/envs';
import {
  AccountsRedirectionKey,
  AccredibleAccountsRedirectionService,
} from '@accredible-frontend-v2/services/accounts-redirection';
import { AccredibleAuthenticationApiService } from '@accredible-frontend-v2/services/authentication';
import { AccredibleCookiesService } from '@accredible-frontend-v2/services/cookies';
import {
  AccredibleLanguageService,
  registerSupportedLocalesData,
} from '@accredible-frontend-v2/services/language';
import { WindowHelper } from '@accredible-frontend-v2/utils/window-helper';
import { DOCUMENT } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { inject, Injectable } from '@angular/core';

const TOKEN_PARAM = 'token';

@Injectable()
export class LerLoadService {
  private readonly _document = inject<Document>(DOCUMENT);
  private readonly _authenticationApi = inject(AccredibleAuthenticationApiService);
  private readonly _cookies = inject(AccredibleCookiesService);
  private readonly _language = inject(AccredibleLanguageService);
  private readonly _accountsRedirection = inject(AccredibleAccountsRedirectionService);

  initializeApp(): Promise<boolean> {
    return new Promise((resolve) => {
      this._setLanguages();
      resolve(true);
    });
  }

  validateAuthenticationToken(): Promise<boolean> {
    return new Promise((resolve) => {
      const urlParams = new URLSearchParams(this._document.location.search);

      if (urlParams.has(TOKEN_PARAM)) {
        this._cookies.set(AccountsRedirectionKey.SESSION_TOKEN_COOKIE, urlParams.get(TOKEN_PARAM));
        this._checkSession().then((isLoggedIn) => resolve(isLoggedIn));

        WindowHelper.removeQueryParamFromUrl(TOKEN_PARAM, urlParams);
      } else if (this._cookies.check(AccountsRedirectionKey.SESSION_TOKEN_COOKIE)) {
        this._checkSession().then((isLoggedIn) => resolve(isLoggedIn));
      } else {
        this._redirectToLogin();
        resolve(false);
      }
    });
  }

  private _checkSession(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this._authenticationApi.checkSession(environment.lerUrl).subscribe({
        next: () => resolve(true),
        error: () => {
          this._redirectToLogin();
          resolve(false);
        },
      });
    });
  }

  private _redirectToLogin(): void {
    this._document.location.href = this._accountsRedirection.getLoginUrlOrigin('ler');
  }

  private _setLanguages(): void {
    registerSupportedLocalesData([
      {
        code: 'en',
        name: 'English (US)',
        matLib: localeEn,
      },
    ]);

    this._language.setLanguage('en');
  }
}
